// Path: ./src/app/pages/CreateDealsPage/index.tsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { CreateDealTopNav } from "../../components/CreateDealTopNav";
import { useLocation, useNavigate } from "react-router-dom";
import { messages } from "../../../locales/messages";
import { useTranslation } from "react-i18next";
import { routes } from "../../../utils/constant/navigationRoutes";

interface Props {
  children?: React.ReactNode;
}
const CreateDeals = ({ children }: Props) => {
  const { t } = useTranslation();

  const [selectedTab, setSelectedTab] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const ButtonList = [
    {
      label: t(messages.Overview()),
      requiredPermission: ["view"],
      requiredPermissionGroup: ["deals"],
      dataTestId: "create-deals-overview-tab",
    },
    {
      label: t(messages.Add_Deal()),
      requiredPermission: ["create"],
      requiredPermissionGroup: ["deals"],
      dataTestId: "create-deals-add-deal-tab",
    },
    {
      label: t(messages.Previous_Deal()),
      requiredPermission: ["view"],
      requiredPermissionGroup: ["deals"],
      dataTestId: "create-deals-previous-deal-tab",
    },
  ];

  /**
   * Handles the selection of a tab and navigation based on the selected tab value.
   * @param value - The index of the selected tab.
   */
  const handleSelectTab = (value: number) => {
    setSelectedTab(value);
    switch (value) {
      case 0:
        navigate(routes.createDeal.view);
        break;
      case 1:
        navigate(routes.createDeal.create);
        break;
      case 2:
        navigate(routes.createDeal.previous);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (location?.pathname) {
      switch (location.pathname) {
        case routes.createDeal.view:
          setSelectedTab(0);
          break;
        case routes.createDeal.create:
          setSelectedTab(1);
          break;
        case routes.createDeal.previous:
          setSelectedTab(2);
          break;
        default:
          break;
      }
    }
  }, [location?.pathname]);
  return (
    <Container data-testid="createdeals-test-id">
      <CreateDealTopNav
        selected={selectedTab}
        onClick={handleSelectTab}
        renderList={ButtonList}
      />
      {children}
    </Container>
  );
};

const Container = styled.div`
  overflow-x: hidden;
`;

export default CreateDeals;
